/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { documentsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDocuments";
import FileDownload from "@monsma/XDL/Icons/FileDownload";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
        @media print {
            page-break-inside: avoid;
            break-inside: avoid;
        }
    `,
};

documentsStyles.container = {
    gap: 15,
};

documentsStyles.documentLink = {
    icon: {
        iconProps: {
            src: FileDownload,
            color: "common.ui5",
            size: 16,
        },
        position: "left",
    },
    typographyProps: {
        size: 15,
        lineHeight: "26px",
        weight: 600,
    },
};
